<template>
  <v-container fluid>
    <CompaniesTable class="pb-4">
      <template v-slot:actions="{ dataset }">
        <avs-exportButton
          :data="dataset"
          :prepare="preFmtData"
          :name="$t('actions.export_')"
          :spantext="$t('actions.export', { entity: $tc('categories.staff.name', 2) })"
        />
        <avs-createButton
          v-if="$store.getters['app/isUserSuperUser']"
          @click="save"
          :spantext="
            $t('Regulariser les bons')
          "
          :name="
            $t('Regulariser les bons')
          "
        />
      </template>
    </CompaniesTable>
  </v-container>
</template>
<script>
import { CompaniesTable } from "@/components"
import { fmtCfsiData } from "@/utils/download"
import { CompanyVouchersService } from "@/services"

export default {
  name: "CompanyView",
  components: { CompaniesTable },
  methods: {
    preFmtData(dataset) {
      return fmtCfsiData(dataset)
    },
    save() {
      CompanyVouchersService.regularize(this).then(response => {
        this.$store.commit("app/message", {
          msg: response.message,
          color: response.status
        })

      })
    },
  }
}
</script>
